import React from 'react';
import type { StageSize } from '../../../../types/canvas.types';
import { FaRegStar } from 'react-icons/fa';
import { Html } from 'react-konva-utils';
import { FaStar } from 'react-icons/fa';
import { useFileActions } from '@/hooks/useFileActions';
import { downloadFile } from '@/utils/utils';
import { MdOutlineFileDownload, MdDeleteOutline } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { BiBug } from 'react-icons/bi';
import { IconButton } from '@/components/ui/IconButton';
import type {
  FileResultResponse,
  FileNotesResponse,
} from '@/features/analysis/types/api.types';
import { FaRegStickyNote } from 'react-icons/fa';
import { useTour } from '@reactour/tour';
import { useMockState } from '@/components/Tutorial/mocks/mockState';

interface CanvasActionControlsProps {
  stageSize: StageSize;
  resultData: FileResultResponse;
  downloadData?: Blob;
  setIsPopupOpen: (isOpen: boolean) => void;
  setIsNotesModalOpen: (isOpen: boolean) => void;
  notesData?: FileNotesResponse;
}

const CanvasActionControls: React.FC<CanvasActionControlsProps> = ({
  stageSize,
  resultData,
  downloadData,
  setIsPopupOpen,
  setIsNotesModalOpen,
}) => {
  const { toggleFavorite, toggleArchive } = useFileActions();
  const navigate = useNavigate();
  const { isOpen, setCurrentStep, currentStep } = useTour();
  const { isFavorite, toggleMockFavorite } = useMockState();

  const handleDownload = () => {
    if (downloadData && resultData?.nom) {
      downloadFile(downloadData, resultData.nom);
    }
  };

  const handleFavoriteClick = () => {
    if (isOpen) {
      if (currentStep === 2) {
        toggleMockFavorite();
        setCurrentStep(3);
      } else {
        toggleMockFavorite();
      }
    } else {
      toggleFavorite(resultData?.id, resultData?.favori);
    }
  };

  const showFavorite = isOpen ? isFavorite : resultData?.favori;

  return (
    <>
      <Html
        transformFunc={(attrs) => ({
          ...attrs,
          x: stageSize.width - 55,
          y: 14,
        })}
      >
        <div className="flex flex-col gap-y-2" id="canvas-actions">
          <IconButton
            icon={
              showFavorite ? (
                <FaStar className="text-lg" />
              ) : (
                <FaRegStar className="text-xl" />
              )
            }
            tooltipContent="Ajouter aux favoris (Entrée)"
            tooltipPlace="left"
            onClick={handleFavoriteClick}
            isActive={showFavorite}
          />
          <IconButton
            icon={<MdOutlineFileDownload className="text-xl" />}
            tooltipContent="Télécharger"
            tooltipPlace="left"
            onClick={handleDownload}
          />
          <IconButton
            icon={<FaRegStickyNote className="text-xl" />}
            tooltipContent="Notes"
            tooltipPlace="left"
            onClick={() => setIsNotesModalOpen(true)}
          />
          <IconButton
            icon={<MdDeleteOutline className="text-xl" />}
            tooltipContent="Archiver"
            tooltipPlace="left"
            onClick={() => {
              toggleArchive(resultData?.id, false);
              navigate('/');
            }}
          />
          <IconButton
            icon={<BiBug className="text-xl" />}
            tooltipContent="Reporter un bug"
            tooltipPlace="left"
            onClick={() => setIsPopupOpen(true)}
          />
        </div>
      </Html>
    </>
  );
};

export default CanvasActionControls;
